var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SwingBySwingApi } from "../services/swingbyswingapi";
import { Player } from "../lib/types";
import { PlayerExtendedStatsCollection } from "../lib/types";
var Players = /** @class */ (function (_super) {
    __extends(Players, _super);
    function Players() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get an authorized players information
     *
     */
    Players.prototype.get = function (playerId) {
        var _this = this;
        if (playerId === void 0) { playerId = "me"; }
        return this.request("GET", "players/" + playerId).then(function (r) {
            return _this.mapResponse(new Player(), r.data);
        });
    };
    Players.prototype.getExtendedStats = function (playerId, from, to, monthMin, yearMin, combineBy) {
        var _this = this;
        if (playerId === void 0) { playerId = ""; }
        if (from === void 0) { from = 1; }
        if (to === void 0) { to = 20; }
        if (monthMin === void 0) { monthMin = 1; }
        if (yearMin === void 0) { yearMin = 2019; }
        if (combineBy === void 0) { combineBy = "none"; }
        return this.request("GET", "playerextendedstats/" + playerId, {
            from: from,
            to: to,
            monthMin: monthMin,
            yearMin: yearMin,
            combineBy: combineBy
        }).then(function (r) {
            return _this.mapResponse(new PlayerExtendedStatsCollection(), r.data);
        });
    };
    /**
     * Update account for an authorized player
     *
     * @param firstName   The updated first name
     * @param lastName    The updated last name
     * @param gender      The updated gender
     * @param privacyType The updated privacy type
     * @param password    The updated password
     */
    Players.prototype.update = function (firstName, lastName, gender, privacyType, password) {
        var _this = this;
        return this.request("PUT", "players", {
            firstName: firstName,
            lastName: lastName,
            isMale: gender,
            securityType: privacyType,
            password: password
        }).then(function (r) {
            return _this.mapResponse(new Player(), r.data);
        });
    };
    return Players;
}(SwingBySwingApi));
export { Players };
